import { render, staticRenderFns } from "./ReceiptsList.vue?vue&type=template&id=33f8185d&scoped=true&"
import script from "./ReceiptsList.vue?vue&type=script&lang=js&"
export * from "./ReceiptsList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsList.vue?vue&type=style&index=0&id=33f8185d&lang=scss&scoped=true&"
import style1 from "./ReceiptsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f8185d",
  null
  
)

export default component.exports